<template>

    <fragment v-if="ready">

        <div v-show="licenseWindow" id="license-window" class="general-popup">

            <div class="wrapper">

                <div v-if="doingPurchase" class="show-spinner">
                    <spinner />
                </div>

                <span class="close-popup" v-on:click.prevent="closePopUpPurchaseWindow"><i class="fas fa-times"></i></span>

                <div v-for="(row, index) in licenseMessage" :key="index">
                    <h2 v-if="row.title">{{ row.title }}</h2>
                    <p v-if="row.message" v-html="row.message"></p>
                </div>

                <div v-if="continueEdit" class="button-wrap">

                    <fragment v-if="noLicense">

                        <a class="btn btn-primary" :disabled="formSubmitted" v-on:click.prevent="submitProject($event, false)">{{ language.save_draft }}</a>

                        <a class="cancel" @click.prevent="continueEdit=false; licenseWindow=false" href="#">{{ language.continue_editing }}</a>

                    </fragment>

                    <fragment v-else>

                        <a href="#" v-on:click.prevent="openProject" target="_blank" class="btn btn-primary">{{ language.to_dialogue }}</a>

                        <a v-if="mode === 'edit'" class="cancel" @click.prevent="continueEdit=false; licenseWindow=false" href="#">{{ language.continue_editing }}</a>

                        <a v-if="mode !== 'edit'" class="cancel" :href="editUrl">{{ language.continue_editing }}</a>

                    </fragment>

                </div>

                <div v-if="!continueEdit" class="button-wrap">

                    <button v-if="!buyLicense" type="submit" class="btn btn-primary" v-on:click.prevent="addLicense">{{ language.yes_publish }}</button>

                    <a v-if="!buyLicense" class="cancel" href="#" @click="licenseWindow=false">{{ language.no_cancel }}</a>

                    <form v-display-none="buyLicense">

                        <input type="hidden" name="licenses" id="licenses" value="1" />

                        <div id="registration-card-error" style="display: none;">
                            <div id="registration-card-error-message" class="alert alert-danger" role="alert"></div>
                        </div>

                        <div class="form-group">
                            <label>{{ language.enter_credit_card}}</label>
                            <div id="payment-card"></div>
                        </div>

                        <div class="form-group submit">
                            <button type="submit" class="btn btn-primary" v-on:click.prevent="purchaseLicense">{{ language.buy_license }}</button>
                            <a class="cancel" href="#" @click="licenseWindow=false">{{ language.cancel }}</a>
                        </div>

                    </form>

                </div>

            </div>

        </div>

        <div v-if="dialogueHasComments" class="confirmation bg-warning">

            <p>{{ language.delete_answers_info }}

                <delete-popup
                    @deleted="answersBeenDeleted"
                    :route="`/api/delete-answers/${dataStore.currentProjectID}`"
                    :text="language.delete_answers_text"
                    :ajaxreq="true"
                    :name="language.delete_answers_name"
                    :button-text="language.delete_answers_button"
                    :translations="JSON.stringify(language.delete_translations)"
                />

            </p>

        </div>

        <header class="b-border">
            <h1 v-if="mode === 'create'" v-html="language.create_project_title"></h1>
            <p v-html="language.project_header_info"></p>
        </header>

        <div v-if="dataStore.showMessage" class="confirmation" v-bind:class="{ 'bg-success': dataStore.messageSuccess, 'bg-danger': !dataStore.messageSuccess }">
            <p>{{ dataStore.message }}</p>
        </div>

        <div v-if="Object.keys(dataStore.errors).length" class="confirmation bg-danger">
            <ul class="errors">
                <li v-for="(error, index) in dataStore.errors" :key="'error-' + index">{{ error }}</li>
            </ul>
        </div>

        <div class="create-project" id="create-project">

            <form enctype="multipart/form-data">

                <div class="row">

                    <div v-if="mode === 'create'" class="col-12">

                        <ul class="nav create-mode nav-tabs">

                            <li class="nav-item">
                                <a class="nav-link" :class="{ active : createType === 'SIMPLE' }" @click.prevent="createType='SIMPLE'" href="#">{{ language.simple_verion }}</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" :class="{ active : createType === 'ADVANCED' }" @click.prevent="createType='ADVANCED'" href="#">{{ language.advanced_verion }}</a>
                            </li>

                        </ul>

                    </div>

                    <div class="col-12 col-lg-9 left-column">

                        <fieldset>

                            <legend class="before-subtitle">{{ language.provide_comment }}<helpbox @help-box-open="helpBoxOpen" :info="help.legend.items" /></legend>

                            <h3 class="subtitle">{{ language.add_comments }}</h3>

                            <add-item></add-item>

                            <span class="error-text-project-items" v-if="dataStore.errors.hasOwnProperty('projectItems')">{{ dataStore.errors.projectItems }}</span>

                            <items v-on:remove-item="removeItem"></items>

                            <h3 class="subtitle" v-if="showGoodBad">{{ language.add_type_place_question_title }}<helpbox @help-box-open="helpBoxOpen" :info="help.legend.give_opinion" /></h3>

                            <div v-if="showGoodBad" class="form-group right-align">
                                <div class="holder">
                                    <label for="add-good-options">{{ language.add_type_place_question_good }}</label>
                                    <div class="form-group-wrap" >
                                        <new-search-and-add :model="'goodOption'" :placeholder="language.add_type_place_question_good_placeholder" :name="'add-good-options'" :type="'Option'" :column="'value'" />
                                    </div>
                                </div>
                            </div>

                            <div v-if="showGoodBad" class="form-group right-align">
                                <div class="holder">
                                    <label for="add-bad-options">{{ language.add_type_place_question_bad }}</label>
                                    <div class="form-group-wrap" >
                                        <new-search-and-add :model="'badOption'" :placeholder="language.add_type_place_question_bad_placeholder" :name="'add-bad-options'" :type="'Option'" :column="'value'" />
                                    </div>
                                </div>
                            </div>

                        </fieldset>

                        <fieldset v-if="mode === 'edit' || createType === 'ADVANCED'">

                            <legend>{{ language.welcome_window_legend }}<helpbox @help-box-open="helpBoxOpen" :info="help.legend.welcome" /></legend>

                            <text-area v-model="dataStore.project.beforeText" :class="{ error: dataStore.errors.hasOwnProperty('beforeText')}" :input-id="'beforetext'" :input-label="language.welcome_before" :input-placeholder="language.welcome_before_placeholder" :has-date="dataStore.project.startDate ? true : false" :sub-label="dataStore.project.startDate ? `Visas till ${dataStore.project.startDate}` : language.welcome_before_info" />

                            <text-area v-model="dataStore.project.welcomeText" :class="{ error: dataStore.errors.hasOwnProperty('welcomeText')}" :input-id="'welcometext'" :input-label="language.welcome_during" :input-placeholder="language.welcome_during_placeholder" :has-date="dataStore.project.startDate ? true : false" :sub-label="dataStore.project.startDate ? `Visas från ${dataStore.project.startDate} till ${dataStore.project.endDate}` : language.welcome_during_info" />

                            <text-area v-model="dataStore.project.endText" :class="{ error: dataStore.errors.hasOwnProperty('endText')}" :input-id="'endtext'" :input-label="language.welcome_during" :input-placeholder="language.welcome_during_placeholder" :has-date="dataStore.project.endDate ? true : false" :sub-label="dataStore.project.endDate ? `Visas efter ${dataStore.project.endDate}` : language.welcome_after_info" />

                        </fieldset>

                        <fieldset v-if="mode === 'edit' || createType === 'ADVANCED'">

                            <legend>{{ language.thank_you_legend }}</legend>

                            <text-area v-model="dataStore.project.thank_you" :class="{ error: dataStore.errors.hasOwnProperty('thank_you_title')}" :input-id="'thank_you'" :input-label="language.thank_you_info" :input-placeholder="language.thank_you_text_placeholder" />

                        </fieldset>

                        <fieldset v-if="mode === 'edit' || createType === 'ADVANCED'">

                            <legend>{{ language.submit_legend }}<helpbox @help-box-open="helpBoxOpen" :info="help.legend.send_opinion" /></legend>

                            <div v-if="mode === 'edit' || createType === 'ADVANCED'" class="form-group checkbox-groups">

                                <div v-for="obj in dataStore.project.allowOptions" :key="obj.id" class="form-check allow">

                                    <label :for="`allow-types-options-${obj.id}`" class="form-check-label">
                                        <input type="checkbox" v-model="dataStore.project.allowOptions[obj.model].allow" class="form-check-input" :id="`allow-types-options-${obj.id}`">
                                        {{ obj.name }}
                                    </label>

                                    <div v-if="obj.model === 'hide_terms' && dataStore.project.allowOptions[obj.model].allow"  class="form-group-wrap">
                                        <wysiwyg />
                                    </div>

                                </div>
                            </div>

                            <div class="form-group right-align">
                                <div class="holder">
                                    <label for="types"><input v-if="editable" type="checkbox" v-model="dataStore.project.allowGenders" class="form-check-input" id="allow-type-options"> {{ language.gender }}</label>
                                    <div class="form-group-wrap" >
                                        <new-search-and-add :model="'gender'" :placeholder="language.gender_placeholder" :name="'add-gender'" :type="'Gender'" :column="'gender'" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group right-align">
                                <div class="holder">
                                    <label for="types"><input v-if="editable" type="checkbox" v-model="dataStore.project.allowTypes" class="form-check-input" id="allow-type-options"> {{ language.types }}<span :class="{ visible : editable }" class="help-text" v-html="language.types_info"></span></label>
                                    <div class="form-group-wrap" >
                                        <new-search-and-add :model="'type'" :placeholder="language.types_placeholder" :name="'add-type'" :type="'Types'" :column="'type'" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group right-align">
                                <div class="holder">
                                    <label for="add-age"><input v-if="editable" type="checkbox" v-model="dataStore.project.allowAges" class="form-check-input" id="allow-age-options"> {{ language.ages }}</label>
                                    <div class="form-group-wrap" >
                                        <new-search-and-add :model="'age'" :placeholder="language.ages_placeholder" :name="'add-age'" :type="'Ages'" :column="'age'" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group right-align">
                                <div class="holder">
                                    <label for="add-county"><input v-if="editable" type="checkbox" v-model="dataStore.project.allowCounties" class="form-check-input" id="allow-counties-options"> {{ language.counties }}<span :class="{ visible : editable }" class="help-text" v-html="language.counties_info"></span></label>
                                    <div class="form-group-wrap" >
                                        <new-search-and-add :model="'county'" :placeholder="language.counties_placeholder" :name="'add-county'" :type="'Counties'" :column="'name'" />
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset v-if="mode === 'edit' || createType === 'ADVANCED'">
                            <legend>{{ language.view_comments }}<helpbox @help-box-open="helpBoxOpen" :info="help.legend.show_opinion" /></legend>
                            <div class="form-group checkbox-groups">
                                <div v-for="obj in dataStore.project.showOptions" :key="obj.id" v-if="obj.model !== 'hide_continue_discussion'" class="form-check allow">

                                    <label class="form-check-label" :for="`allow-types-options-${obj.id}`">
                                        <input type="checkbox" v-model="dataStore.project.showOptions[obj.model].allow" class="form-check-input" :id="`allow-types-options-${obj.id}`">
                                        {{ obj.name }}<helpbox @help-box-open="helpBoxOpen" :info="help.label[obj.model]" />
                                    </label>

                                </div>
                            </div>
                        </fieldset>

                        <media-pop-up />
                    </div>

                    <div class="col-12 col-lg-3 right-column">

                        <fieldset>

                            <legend>{{ language.project_name_legend }}<helpbox @help-box-open="helpBoxOpen" :info="help.legend.name" /></legend>

                            <div class="form-group" :class="{ error: dataStore.errors.hasOwnProperty('projectName')}">
                                <label for="project-name">{{ language.project_name }}*<helpbox @help-box-open="helpBoxOpen" :info="help.label.project_name" /></label>
                                <input v-model="dataStore.project.projectName" type="text" class="form-control" id="project-name" :placeholder="language.project_name_placeholder">
                            </div>

                            <div v-if="mode === 'edit'" class="form-group form-check">
                                <input v-model="dataStore.project.updateSlug" type="checkbox" class="form-check-input" id="update-slug">
                                <label class="form-check-label" for="update-slug">{{ language.project_slug_update }}</label>
                            </div>

                            <div v-if="mode === 'edit' || createType === 'ADVANCED'" class="form-group image-upload">

                                <label v-if="editable" for="logo">{{ language.project_name_logo }}</label>

                                <input v-if="editable" style="display: none;" type="file" accept="image/png, image/jpeg" class="form-control-file" id="logo-instead" v-on:change="addImageLogo($event, 'logo-instead')">

                                <button v-if="editable" class="btn btn-primary" v-on:click.prevent="globalFunctions.addImageFile('logo-instead')">{{ language.choose_file }}</button>

                                <img v-if="dataStore.project.imageLogoInstead && !dataStore.isDeletingImageLogo" id="logo-image" :class="{'not-allowed-to-edit' : !editable}" class="preview-image" :src="globalFunctions.getLogoUrlInsteadName(dataStore.project.imageLogoInstead)" />

                                <span v-if="dataStore.project.imageLogoInstead && editable" class="remove-image" v-on:click.prevent="removeImage(dataStore.project.imageLogoInstead, 'dataStore.project.imageLogoInstead', 'dataStore.isDeletingImageLogo')">
                                    <i class="fas fa-times-circle"></i>
                                </span>

                                <spinner v-if="dataStore.isDeletingImageLogo && editable" />

                            </div>

                            <div class="form-group">
                                <label for="project-customer">{{ language.customer }}<helpbox @help-box-open="helpBoxOpen" :info="help.label.customer" /></label>
                                <input v-model="dataStore.project.customer" type="text" class="form-control" id="project-customer" :placeholder="language.customer_placeholder">
                            </div>

                            <div v-if="mode === 'edit' || createType === 'ADVANCED'" class="form-group image-upload">

                                <label for="logo">{{ language.customer_logo }}</label>

                                <input v-if="editable" style="display: none;" type="file" accept="image/png, image/jpeg" class="form-control-file" id="logo" v-on:change="addImageLogo($event, 'logo')">

                                <button v-if="editable" class="btn btn-primary" v-on:click.prevent="globalFunctions.addImageFile('organisation')">{{ language.choose_file }}</button>

                                <img id="logo-image" :class="{'not-allowed-to-edit' : !editable}" class="preview-image" v-if="dataStore.project.image && !dataStore.isDeletingImage" :src="globalFunctions.getLogoUrl(dataStore.project.image)" /><span class="remove-image" v-on:click.prevent="removeImage(dataStore.project.image, 'dataStore.project.image', 'dataStore.isDeletingImage')" v-if="dataStore.project.image && editable"><i class="fas fa-times-circle"></i></span>
                                
                                <spinner v-if="dataStore.isDeletingImage && editable" />
                                
                            </div>

                            <div class="form-group">
                                <label>{{ language.language_legend }}</label>
                                <select v-model="dataStore.project.language" class="form-control">
                                    <option v-for="lang in selectLanguages" :key="lang.id" :value="lang.code">{{ lang.name }}</option>
                                </select>
                            </div>

                        </fieldset>

                        <fieldset v-if="mode === 'edit' || createType === 'ADVANCED'">

                            <legend>{{ language.find_place_legend }}</legend>

                            <div class="form-group project-address">

                                <label for="project-address">{{ language.find_place }}<helpbox @help-box-open="helpBoxOpen" :info="help.label.find_place" /></label>

                                <p class="coordinates" v-if="dataStore.project.addressMapCenter">
                                    lat: {{ dataStore.project.addressMapCenter.lat }},<br>
                                    lng: {{ dataStore.project.addressMapCenter.lng }},<br>
                                    zoom: {{ dataStore.project.addressZoom }}
                                </p>

                                <button class="btn btn-primary" v-on:click.prevent="globalFunctions.toggleFindPlace()">{{ language.add }}</button>
                                <!-- https://www.google.se/maps/@55.7065696,13.194544,16z -->
                                <div class="form-group form-check">
                                    <input v-model="dataStore.project.hideMapLink" type="checkbox" class="form-check-input" id="hide-find-place">
                                    <label class="form-check-label" for="hide-find-place">{{ language.find_place_hide }}</label>
                                </div>

                            </div>

                            <div class="form-group">
                                <label for="project-url">{{ language.more_info_link }}<helpbox @help-box-open="helpBoxOpen" :info="help.label.project_url" /></label>
                                <input v-model="dataStore.project.projectUrl" type="url" class="form-control" id="project-url" placeholder="http://">
                            </div>

                            <div class="form-group checkbox-groups">

                                <div class="form-check show-faq">
                                    <input type="checkbox" v-model="dataStore.project.allowFaq" class="form-check-input" id="allow-faq">
                                    <label class="form-check-label" for="allow-faq">{{ language.toggle_faq }}</label>
                                </div>

                            </div>

                            <div class="form-group" v-if="dataStore.project.allowFaq" :class="{ error: dataStore.errors.hasOwnProperty('faqEmail')}">
                                <label for="faq-email">{{ language.faq_email }}</label>
                                <input type="email" v-model="dataStore.project.faqEmail" class="form-control" id="faq-email">
                            </div>

                            <div class="form-group checkbox-groups">

                                <div class="form-check spam-protection">
                                    <input type="checkbox" v-model="dataStore.project.spamProtection" class="form-check-input" id="spam-protection">
                                    <label class="form-check-label" for="spam-protection">Spam Protection</label>
                                </div>

                            </div>

                        </fieldset>

                        <fieldset v-if="mode === 'edit' || createType === 'ADVANCED'">
                            <legend>{{ language.dialogue_phases_legend }}<helpbox @help-box-open="helpBoxOpen" :info="help.label.project_state" /></legend>
                            <project-state />
                        </fieldset>

                        <fieldset>
                            <legend>{{ language.open_for_comment_legend }}<helpbox @help-box-open="helpBoxOpen" :info="help.legend.open_for_opinion" /></legend>
                            <div class="form-group" :class="{ error: dataStore.errors.hasOwnProperty('startDate')}">
                                <label>{{ language.start_date }}*</label>
                                <input v-model="dataStore.project.startDate" type="date" name="bday" max="3000-12-31" min="1000-01-01" class="form-control start-date">
                            </div>

                            <div class="form-group" :class="{ error: dataStore.errors.hasOwnProperty('endDate')}">
                                <label>{{ language.end_date }}*</label>
                                <input v-model="dataStore.project.endDate" type="date" name="bday" min="1000-01-01" max="3000-12-31" class="form-control end-date">
                            </div>
                        </fieldset>

                        <fieldset v-if="mode === 'edit' && user.myRoles.includes('master-admin') && dataStore.project.license">
                            <legend>{{ language.license_legend }}</legend>
                            <div class="form-group">
                                <select v-model="dataStore.project.projectLevel" class="form-control">
                                    <option value="BAS">{{ language.products_basic }}</option>
                                    <option value="SUPPORT">{{ language.products_support }}</option>
                                    <option value="RAPPORT">{{ language.products_report }}</option>
                                    <option value="PREMIUMLICENS">{{ language.products_premium }}</option>
                                </select>
                            </div>
                        </fieldset>

                        <fieldset class="status">

                            <legend>{{ language.status_legend }}</legend>

                            <nav>

                                <ul class="actions">

                                    <li><a class="btn btn-secondary" :disabled="formSubmitted" v-on:click.prevent="submitProjectDefault($event, false)">{{ language.save_draft }}</a></li>

                                    <li v-if="mode === 'edit'"><a class="btn btn-secondary" target="_blank" :href="previewLink">{{ language.preview }}</a></li>
                                    
                                </ul>

                            </nav>

                            <nav>

                                <label>{{ language.status_legend }}:<br><span v-if="mode === 'edit'">{{ dataStore.project.isPublic === 0 ? language.draft : language.published }}</span><span v-else>{{ language.not_created }}</span></label>

                                <ul class="actions status-actions">
                                    <li><a class="btn btn-secondary" href="/admin">{{ language.cancel }}</a></li>
                                    <li><a class="btn btn-primary" :disabled="formSubmitted" v-on:click.prevent="submitProjectDefault($event, true)">{{ language.publish }}</a></li>
                                </ul>

                            </nav>

                        </fieldset>

                        <fieldset v-if="mode === 'edit' && dataStore.project.license === null && user.myRoles.includes('master-admin')">
                            <legend>Licens</legend>
                            <nav>
                                <ul class="actions status-actions">
                                    <li><a class="btn btn-primary" v-on:click.prevent="addLicenseAdmin">Tilldela</a></li>
                                </ul>
                            </nav>
                        </fieldset>

                    </div>

                </div>

            </form>

            <find-place />

        </div>

        <div v-if="showWarning">

            <transition name="modal">
                <div class="modal-mask" @click="closeMe($event)">
                    <div class="modal-wrapper">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" v-html="language.warning"></h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" @click="showWarning = false">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p v-html="language.warning_desc"></p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="showWarning = false">{{ language.close }}</button>
                                <button class="btn btn-danger delete-button" v-on:click.prevent="submitProjectAdmin">{{ superAdminArguments[1] ? language.publish : language.save_draft }}</button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

            </transition>

        </div>

    </fragment>

</template>

<script>

import axios from "axios";
import { Fragment } from 'vue-fragment'

import dataStore from "../store";
import globalFunctions from "../globalFunctions";

import Items from "./Project/Items";
import AddItem from "./Project/AddItem";
import MediaPopUp from './Project/MediaPopUp';
import FindPlace from './Project/FindPlace'
import Helpbox from './Project/Helpbox';
import ProjectState from './Project/ProjectState';
import Wysiwyg from './Project/Wysiwyg'

import TextArea from './form/TextArea';


import Spinner from './Spinner'
import NewSearchAndAdd from './NewSearchAndAdd'

import DeletePopup from './DeletePopup'


import uuid from "uuid";

const _ = require('lodash');

export default {

    components: {
        Items,
        AddItem,
        MediaPopUp,
        Fragment,
        FindPlace,
        Helpbox,
        ProjectState,
        NewSearchAndAdd,
        DeletePopup,
        Wysiwyg,
        Spinner,

        TextArea
    },

    data() {
        return this.initialState();
    },

    provide() {
        return {
            superadmin : this.superadmin,
            dialogueHasComments : this.dialogueHasComments
        }
    },

    inject: [ 'language' ],

    props: {
        mode : String,
        help : Object,
        superadmin : Boolean,
        user : Object,
        token : String,

        selectLanguages : {
            type: Array,
            default: () => []
        },

        currentLanguage : {
            type: String,
            default: 'en'
        },

        addurl: {
            type: String,
            default: null
        },

        geturl:  {
            type: String,
            default: null
        }

    },

    async mounted() {

        this.dataStore.project.language = this.currentLanguage

        this.setStoreTranslations()

        if(this.mode === 'edit') {

            this.dataStore.currentProjectID = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

            let projectLoaded = await this.getProject(this.dataStore.currentProjectID);

            const projectGotCreated = window.location.search.substr(1);

            if(projectGotCreated.includes('save=true')) {
                this.createdProjectReplaceUrl()
            }

            if(projectLoaded) {
                let url = window.location.origin + '/' + this.dataStore.project.slug + '/';
                this.dataStore.project.currentUrl = this.dataStore.project.isPublic == 0 ? url + this.dataStore.project.guid : this.geturl
            }

        } else {

            try {
                this.dataStore.project.guid = await this.createUniqueGuid();
                this.dataStore.project.allowToEdit = true;
                this.dataStore.isLoaded = true;
                this.ready = true;
            } catch (error) {
                console.error(error);
            }

        }

    },

    computed: {

        showGoodBad: function() {

            if(this.dataStore.projectItems.length) {

                let res = this.dataStore.projectItems.some(el => {

                    if(el.question && el.question.type === 'goodbad') {
                        return el;
                    } else if(el.questionType === 'goodbad') {
                        return el;
                    }

                })

                return res ? true : false
            }

            return false
        },

        previewLink: function() {
            return window.location.origin + '/' + this.dataStore.project.slug + '/' + this.dataStore.project.guid;
        },

        dialogueHasComments: function() {
            return ! (this.dataStore.project.allowToEdit && this.dataStore.isLoaded) 
        },

        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        }
    },

    methods: {

        openProject: function() {

            window.open( this.dataStore.project.currentUrl , '_blank').focus()

            this.continueEdit = false

            this.licenseWindow = false

        },

        setStoreTranslations: async function() {

            const lang = this.mode === 'create' ? this.currentLanguage : this.dataStore.project.language

            const { data } = await axios.get('/api/translations/admin/' +  lang )

            const translations = data

            this.dataStore.project.beforeText = translations.welcome_before_default
            this.dataStore.project.welcomeText = translations.welcome_during_default
            this.dataStore.project.endText = translations.welcome_after_default

            this.dataStore.project.allowOptions.hide_name.name = translations.submit_allow_name
            this.dataStore.project.allowOptions.hide_address.name = translations.submit_allow_address
            this.dataStore.project.allowOptions.hide_email.name = translations.submit_allow_email
            this.dataStore.project.allowOptions.hide_terms.name = translations.submit_allow_terms

            this.dataStore.project.showOptions.hide_report.name = translations.submit_allow_report
            this.dataStore.project.showOptions.hide_share.name = translations.submit_allow_share
            this.dataStore.project.showOptions.hide_continue_discussion.name = translations.submit_allow_continue_discussion
            this.dataStore.project.showOptions.newsletter.name = translations.submit_allow_newsletter

            this.dataStore.project.types = [
                {type: translations.types_resident, sort : 0},
                {type: translations.types_working, sort: 1},
                {type: translations.types_visitor, sort: 2},
                {type: translations.types_property_owner, sort: 3}
            ]

            this.dataStore.project.genders = [
                {gender: translations.gender_female, sort : 0},
                {gender: translations.gender_male, sort: 1},
                {gender: translations.gender_other, sort: 2}
            ]

            this.dataStore.project.counties = [
                {name: translations.counties_in_the_neighborhood, sort : 0},
                {name: translations.counties_in_the_city_district, sort: 1},
                {name: translations.counties_in_the_municipality, sort: 2},
                {name: translations.counties_outside_the_municipality, sort: 3}
            ]

            this.dataStore.project.thank_you_title = translations.thank_you_title

            this.dataStore.project.thank_you = translations.thank_you_message

            this.dataStore.hint = translations.add_type_hint_default

        },

        answersBeenDeleted: function(delted) {

            if(delted) {
                this.dataStore.project.allowToEdit = true;
                this.showMessage(this.language.deleted, true)
            } else {
                this.showMessage(this.language.something_went_wrong, false)
            }

        },

        closePopUpPurchaseWindow: function() {

            if( ( this.editUrl === '' && this.mode === 'create' ) || this.mode === 'edit' ) {
                this.licenseWindow = false
            }
            else {
                window.location.replace(this.editUrl)
            }
        },

        createUniqueGuid: async function() {

            try {

                let guids = await this.checkGuid()

                if(guids.data) {

                    let guid = uuid.v4();

                    if(guids.data.includes(guid)) {

                        do {
                            guid = uuid.v4();
                        }

                        while (guids.data.includes(guid));

                    }

                    return guid;

                } else {
                    return uuid.v4();
                }

            } catch (error) {
                console.error(error);
            }

        },

        checkGuid: async function() {
            return axios.get(`/api/check-guids-admin`)
        },

        helpBoxOpen: function(event) {

            document.addEventListener('click', (subevent) => {

                if(subevent.target.className.includes('is-open-clickbox')) {

                    let helpBoxes = document.getElementsByClassName('is-open-helpbox')
                    subevent.target.classList.remove('is-open-clickbox')

                    for (let element of helpBoxes) {
                        element.classList.remove('is-open-helpbox')
                    }
                }

            })

        },

        removeImage: async function(url, prop, propTwo) {

            _.set(this.$data, prop, false);

            if(this.dataStore.currentProjectID) {

                try {
                    _.set(this.$data, propTwo, true);

                    const response = await axios.post(`/api/delete-image`, { image : url, value : prop, project_id : this.dataStore.currentProjectID, headers: { 'Content-Type': 'multipart/form-data' } } )

                    if(response && response.data) {
                        _.set(this.$data, propTwo, false);
                    }
                } catch (error) {
                    console.error(error);
                }
            }

        },

        addImageLogo: function(e, type) {
            let file = e.target.files[0];
            let path = type == 'logo' ? 'dataStore.project.currentImageName' : 'dataStore.project.currentImageNameLogoInstead';
            let fileToUse = type == 'logo' ? 'dataStore.project.image' : 'dataStore.project.imageLogoInstead';

            type == 'logo' ? this.createImage(file,'dataStore.project.image') : this.createImage(file,'dataStore.project.imageLogoInstead')

            _.set(this.$data, path, file.name);
            _.set(this.$data, fileToUse, file);
        },

        addToList: function(prop, value, name, event, column){
            let val = _.get(this.$data, prop);

            event.target.disabled = true;

            if(value !== ''){
                val.push(value);
                _.set(this.$data, name, '');
            }

            let maped = val.map(v => typeof v === 'object' ? v[column] : v)

            let unique = [...new Set(maped)];
            _.set(this.$data, prop, unique);

            if(event) {
                let children = event.target.parentNode.children;

                if(children.length) {
                    for (let i = 0; i < children.length; i++) {
                        if(children[i].tagName === 'INPUT') {
                            children[i].value = ''
                        }
                    }
                }
            }

            event.target.disabled = false;
        },

        removeFromList: function(e, prop, value) {

            e.stopPropagation();

            let val = _.get(this.$data, prop);

            if(this.editable) {
                let index = val.indexOf(value);
                val.splice(index, 1);
            }

            if(prop === 'dataStore.project.projectState'){

                if(this.dataStore.project.projectState.length > 0 && !this.dataStore.project.projectState.includes(this.dataStore.project.currentProjectState)){
                    this.dataStore.project.currentProjectState = '';
                }

                else if(this.dataStore.project.projectState.length === 0){
                    this.dataStore.project.currentProjectState = '';
                }
            }
        },

        mapStates: function(states) {

            if(states && states.length === 5) {
                return states;
            } else {
                let diff = 5 - states.length;

                while(diff > 0) {
                    states.push({
                        name : '',
                        link : ''
                    })

                    diff--
                }

                return states;
            }
        },

        createImage(file, path) {
            let reader = new FileReader();
            let vm = this;

            reader.onload = (e) => {
                _.set(vm.$data, path, e.target.result);
            };

            reader.readAsDataURL(file);
        },

        getOptionsFromProject: function(items){

            if(items.length){

                this.dataStore.project.goodOptions = [];
                this.dataStore.project.badOptions = [];
                this.dataStore.project.scaleOptions = [];

                for(let item of items){

                    if(item.question && item.question.options && item.question.options.length ){

                        item.question.options.map((option) => {

                            if(option.type === 'good'){
                                this.addOption(this.dataStore.project.goodOptions, option.value, option)
                            }

                            if(option.type === 'bad'){
                                this.addOption(this.dataStore.project.badOptions, option.value, option)
                            }

                            if(option.type === 'scale'){
                                this.addOption(this.dataStore.project.scaleOptions, option.value, option)
                            }
                        })
                    }
                }
            }
        },

        addOption: function(arr, val, option) {
            const found = arr.some(el => el.value === val);
            if (!found) arr.push(option);
            return arr;
        },

        removeItem: async function(item) {
            this.dataStore.message = 'Raden har tagits bort.';
            this.dataStore.messageSuccess = true;
            this.dataStore.showMessage = true;

            window.scroll(0,0);

            this.getProject(this.dataStore.currentProjectID);

            setTimeout(() => {
                this.dataStore.showMessage = false;
                this.dataStore.messageSuccess = false;
                this.dataStore.message = '';
            } , 5000);

        },

        addLicense: function(e) {

            this.$data.dataStore.addLicense = true;

            if(this.mode === 'create'){
                this.createProject(true);
            } else {
                this.editProject(true);
            }

        },

        addLicenseAdmin: async function() {

            const { data } = await axios.post('/api/add-license-admin', { slug : this.dataStore.project.slug, user_id: this.user.id, headers: this.headers } )

            if(data) {
                this.showMessage(data.message, data.status)

                if(data.license) {
                    this.dataStore.project.license = data.license
                }
            }
        },

        openProjectInTab: function(data) {

            if( data.published ) {
                window.open( data.redirect ,'_blank')
            } 

        },

        submitProjectDefault: function() {

            if( this.dialogueHasComments && this.superadmin ) {
                this.superAdminArguments = arguments
                this.showWarning = true
            } else {
                this.submitProject.apply(null, arguments)
            }

        },

        submitProjectAdmin: async function() {
            this.submitProject.apply(null, this.superAdminArguments)
        },
        // draftOrPublish | publish = true, draft = false

        submitProject: async function(e, draftOrPublish) {

            if(this.formSubmitted) return;

            this.continueEdit = false 

            this.licenseWindow = false

            this.dataStore.errors = {}

            try {

                const { data } = await axios.post('/api/validate-project', { data : this.$data.dataStore, user_id : this.user.id, headers: this.headers } )

                if(data) {

                    if(data.errors && Object.keys(data.errors).length > 0) {
                        this.dataStore.errors = data.errors;
                        window.scroll(0,0);
                        return;
                    }

                    // since stripe comment out -- if you are not an super admin they need to give you a license 
                    // then check on user if he has a license available - else message show to contact support
                    // needs to be changed later if stripe comming back....

                    let buyLicense = false

                    const license = this.dataStore.project.license

                    let needLicense = false;

                    if( ! this.user.myRoles.includes('master-admin') ) {
                    
                        if( ! this.user.isPro && ! license ) {
                            needLicense = true
                        }

                    }

                    if( needLicense ) {
                        
                        const res = await axios.get('/api/get-license-user/' + this.user.id)

                        buyLicense = res.data.buyLicense

                        if( ! buyLicense ) {
                            this.dataStore.addLicense = true
                        }

                    }

                    // no license on project and tries to publish + needs to buy

                    if( ! license && draftOrPublish && buyLicense ) {

                        // if(data) {
                            this.licenseWindow = true

                            this.licenseMessage = [
                                {
                                    message : this.language.contact_for_license
                                }
                            ] // data.info

                            this.buyLicense =  false // data.buyLicense
                            // this.showStripe

                            this.continueEdit = true

                            this.noLicense = true

                            // if(data.buyLicense) {

                            //     const { data } = await axios.get('/api/get-stripe-details/' + this.user.id)

                            //     this.stripeDetails = data ? data : null;

                            //     if(this.stripeDetails) {

                            //         const elements = stripe.elements();
                            //         this.cardElement = elements.create('card');
                            //         this.cardElement.mount('#payment-card');
                            //     }
                            // }

                        // }
                    }

                    // allowed as super admin or has a license or Pro
                    else {

                        if(this.mode === 'create'){
                            this.createProject(draftOrPublish);
                        } else {
                            this.editProject(draftOrPublish);
                        }

                    }

                }

            } catch (error) {
                console.error(error);
            }

        },

        editProject: async function(status) {

            this.formSubmitted = true;

            try {

                const { data } = await axios.post(`/api/edit-project/${this.dataStore.currentProjectID}`, { data : this.$data.dataStore, user_id : this.user.id, is_publishing : status, headers: { 'Content-Type': 'multipart/form-data' } } )

                if(data) {

                    if( status ) {
                        this.licenseWindow = true;
                        this.continueEdit = true
                        this.licenseMessage = data.publish_message;
                    }

                    else {
                        this.showMessage(data.message, data.status)
                    }

                    this.formSubmitted = false;
                    this.dataStore.errors = {};
                    this.getProject(this.dataStore.currentProjectID);

                    if(this.dataStore.project.updateSlug) {
                        this.dataStore.project.updateSlug = false
                    }

                    this.openProjectInTab(data)


                    // for superadmin when saving on project with comments
                    this.showWarning = false

                    this.superAdminArguments = null

                }

            } catch (error) {
                this.showMessage(this.language.something_went_wrong, false)
            }

        },

        createProject: async function(publish) {

            this.formSubmitted = true;

            try {

                const { data } = await axios.post('/api/create-project-admin', { data : this.$data.dataStore, user_id : this.user.id, is_publishing : publish, headers: { 'Content-Type': 'multipart/form-data' } } )

                if(data) {

                    this.formSubmitted = false;

                    const projectLoaded = await this.getProject(data.id);

                    if(projectLoaded) {

                        if( data.status && publish) {
                            this.licenseWindow = true;
                            this.continueEdit = true
                            this.licenseMessage = data.publish_message;
                            this.editUrl = data.url
                        }

                        else {
                            window.location.replace(`${data.url}?save=${data.status}&message=${data.message}`);
                        }

                        this.openProjectInTab(data)

                    }

                }

            } catch (error) {
                console.error(error);
            }

        },

        createdProjectReplaceUrl: function() {

            let queryparams = window.location.search.substr(1)

            if(!queryparams) return

            let params = queryparams.split('&');

            let pair = null, data = [];

            params.forEach(function(d) {
                pair = d.split('=');
                data.push({key: pair[0], value: pair[1]});
            });

            const messageObj = data.find(obj => obj.key === 'message')

            if(!messageObj) return

            this.dataStore.showMessage = true;
            this.dataStore.message = messageObj.value.replaceAll('%20', ' ')
            this.dataStore.messageSuccess = true;

            window.history.pushState({}, document.title, window.location.origin + window.location.pathname);

            setTimeout(() => {
                this.dataStore.showMessage = false;
                this.dataStore.messageSuccess = false;
            } , 5000);
        },

        getProject: async function(id) {

            try {

                let response = await axios.get(`/api/project/${id}`, { headers: { 'Content-Type': 'multipart/form-data' } });

                if (response && response.data) {

                    const { data } = response;

                    const state = data.project_state.find( (state) => data.current_project_state == state.id );

                    let addressInfo = {}, url = window.location.origin + '/' + data.slug + '/';

                    const project = {
                        projectName: data.title,
                        projectLevel: data.license_level,
                        isPublic: data.public,
                        allowToEdit: data.allow_edit,
                        slug: data.slug,
                        license : data.license,
                        logoInsteadOfName: data.logo_instead_name_check,
                        projectState:
                            ! data.project_state ||
                            (data.project_state && data.project_state.length === 0)
                                ? this.dataStore.project.projectState
                                : this.mapStates(data.project_state),
                        startDate: ! data.start_date_fix ? false : data.start_date_fix,

                        endDate: ! data.end_date_fix ? false : data.end_date_fix,
                        image: data.logotype,
                        currentImageName: data.logotype,
                        imageLogoInstead: data.logo_instead_name,
                        currentImageNameLogoInstead: data.logo_instead_name,
                        customer: data.customer && ! data.customer.length > 0 ? '' : data.customer[0].name,
                        projectUrl: ! data.link ? '' : data.link,
                        address: ! data.address ? '' : data.address,
                        textUrl: ! data.link_text ? '' : data.link_text,
                        mapLink: ! data.map_link ? '' : data.map_link,
                        welcomeText: ! data.welcome_text ? this.dataStore.project.welcomeText : data.welcome_text,
                        beforeText: ! data.before_text ? this.dataStore.project.beforeText : data.before_text,
                        endText: ! data.end_text ? this.dataStore.project.endText : data.end_text,
                        thank_you_title: ! data.thank_you_title ? '' : data.thank_you_title,
                        thank_you: ! data.thank_you ? '' : data.thank_you,
                        terms: ! data.terms ? '' : data.terms,
                        types: ! data.types ? [] : data.types,
                        ages: ! data.ages ? [] : data.ages,
                        counties: ! data.counties ? [] : data.counties,
                        genders: ! data.genders ? [] : data.genders,

                        language : ! data.language.code ? this.dataStore.project.language : data.language.code,

                        hideMapLink: data.hide_map_link,

                        allowTypes: data.hide_types,
                        allowAges: data.hide_ages,
                        allowCounties: data.hide_counties,
                        allowGenders: data.hide_sex,

                        allowFaq : data.allow_faq,

                        spamProtection : data.spam_protection,


                        faqEmail : ! data.faq_email ? '' : data.faq_email,

                        guid: ! data.private_link ? uuid.v4() : data.private_link.guid,

                        currentUrl: data.public == 0 ? url + this.dataStore.project.guid : data.get_url,

                        currentProjectState: state && state.hasOwnProperty('id') ? state.name : '',

                        allowOptions: {

                            hide_name: {
                                ...this.dataStore.project.allowOptions.hide_name,
                                allow: data.hide_name,
                            },

                            hide_address: {
                                ...this.dataStore.project.allowOptions.hide_address,
                                allow: data.hide_address,
                            },

                            hide_email: {
                                ...this.dataStore.project.allowOptions.hide_email,
                                allow: data.hide_email,
                            },

                            hide_terms: {
                                ...this.dataStore.project.allowOptions.hide_terms,
                                allow: data.hide_terms,
                            },
                        },

                        showOptions: {

                            hide_report: {
                                ...this.dataStore.project.showOptions.hide_report,
                                allow: data.hide_report,
                            },

                            hide_share: {
                                ...this.dataStore.project.showOptions.hide_share,
                                allow: data.hide_share,
                            },

                            hide_continue_discussion: {
                                ...this.dataStore.project.showOptions.hide_continue_discussion,
                                allow: data.hide_continue_discussion,
                            },

                            newsletter: {
                                ...this.dataStore.project.showOptions.newsletter,
                                allow: data.newsletter,
                                name: this.language.newsletter_message.replacePlaceholders({ name : data.title })
                            },

                        },

                    };

                    if (project.address.length) {

                        const tempAddress = project.address.replace('"', '').split(',');

                        // addressInfo = {
                        //     addressMapCenterLat:
                        //         tempAddress[0] !== undefined
                        //             ? parseFloat(tempAddress[0].replace(/[^\d.-]/g, ''))
                        //             : 0,
                        //     addressMapCenterLng:
                        //         tempAddress[1] !== undefined
                        //             ? parseFloat(tempAddress[1].replace(/[^\d.-]/g, ''))
                        //             : 0,
                        //     addressZoom: tempAddress[2] !== undefined
                        //         ? parseFloat(tempAddress[2].replace(/[^\d.-]/g, ''))
                        //         : 3,
                        // }

                    }

                    this.getOptionsFromProject(data.items);
                    this.dataStore.isLoaded = true;
                    this.dataStore.project = Object.assign(this.dataStore.project, {
                        ...project,
                        ...addressInfo,
                    });
                    this.dataStore.projectItems = !data.items ? [] : data.items;
                    this.ready = true
                    return true;
                }

            } catch (error) {
                console.error(error);
                return false;
            }
        },

        purchaseLicense: async function(e) {

            e.target.disabled = true;

            $('#registration-card-error').hide();

            stripe.confirmCardSetup(this.stripeDetails.secret ,{ payment_method: {card: this.cardElement} }).then((result) => {

                if (result.error) {

                    $('#registration-card-error').show();
                    $('#registration-card-error-message').html(result.error.message);
                    e.target.disabled = false;

                } else {

                    this.doingPurchase = true;

                    const token = document.head.querySelector('meta[name="csrf-token"]').content;

                    const data = {
                        _token : token,
                        customer_id : this.stripeDetails.customer_id,
                        payment_method : result.setupIntent.payment_method,
                        licenses : 1,
                    }

                    let axiosConfig = {

                        headers: {
                            'Accept': 'application/json',
                            'Authorization' : 'Bearer ' + this.token
                        }

                    };

                    // axiosConfig

                    axios.post('/api/cart/create-purchase/', data )

                    .then((result) => {

                        if(result && result.data && result.data.status === 'success') {

                            this.buyLicense = false;
                            this.licenseMessage = result.data.info;
                            this.doingPurchase = false;

                        }

                        if(result && result.data && result.data.status === 'error') {

                            $('#registration-card-error').show();
                            $('#registration-card-error-message').html(result.data.message);
                            this.doingPurchase = false;

                        }

                    })
                    .catch((err) => {
                        console.log(err)
                        this.doingPurchase = false;
                    })

                }
            });


        },

        closeMe: function(e) {
            if(e.target.classList.contains('general-popup')) {
                e.target.style.display = 'none'
            }
        },

        showMessage: function(message, status, timout = 5000) {

            this.dataStore.message = message
            this.dataStore.messageSuccess = status
            this.dataStore.showMessage = true

            window.scroll(0,0);

            if(this.dataStore.showMessage) {

                setTimeout(() => {
                    this.dataStore.showMessage = false
                    this.dataStore.messageSuccess = false
                    this.dataStore.message = ''
                } , timout);
            }

        },

        initialState: function(){

            return {
                dataStore,
                globalFunctions,
                createType : 'SIMPLE',
                ready : false,
                formSubmitted : false,
                licenseWindow : false,
                licenseMessage : '',
                buyLicense : false,
                continueEdit : false,
                stripeDetails : null,
                cardElement: null,
                doingPurchase : false,
                editUrl : '',

                noLicense: false,

                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization' : 'Bearer ' + this.token,
                    // 'Accept' : 'application/json'
                },

                isSubmitting : false,

                showWarning : false,
                
                superAdminArguments : null

            };
        }
    }
};
</script>
